var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', {
    staticClass: "tree-menu-comm"
  }, _vm._l(_vm.data, function (item, index) {
    return _c('li', {
      key: index + '1'
    }, [_c('div', {
      class: `tree-title ${item.check ? 'tree-title-background tree-title-action' : ''}`,
      style: _vm.stylePadding,
      on: {
        "click": function ($event) {
          return _vm.onSelect(item);
        }
      }
    }, [_c('span', [_c('strong', {
      class: `strong${item.type === 'UNIT' ? 'tree-title-blod' : ''} ${item.check ? 'tree-title-color' : ''}`
    }, [_vm._v(_vm._s(item.title))]), _vm.haschildren(item) ? _c('Icon', {
      class: `tree-icon-arrow ${item.check ? 'tree-title-color' : ''}`,
      attrs: {
        "type": item.expand ? 'md-arrow-dropdown' : 'md-arrow-dropright'
      },
      on: {
        "click": e => _vm.foldFn(e, item)
      }
    }) : _vm._e(), _vm.isAdmin ? _c('Poptip', {
      staticClass: "Poptip",
      attrs: {
        "trigger": "hover",
        "placement": "right"
      },
      nativeOn: {
        "click": function ($event) {
          return (e => _vm.stopPropagation(e)).apply(null, arguments);
        }
      }
    }, [_c('Icon', {
      class: `tree-icon-more ${item.check ? 'tree-title-color' : ''}`,
      attrs: {
        "type": "md-more"
      }
    }), _c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, _vm._l(item.more, function (moreItem) {
      return _c('div', {
        key: moreItem.code,
        staticClass: "pop-li",
        on: {
          "click": function ($event) {
            moreItem.confirm ? '' : moreItem.callBack(moreItem.code, item);
          }
        }
      }, [moreItem.confirm ? _c('Poptip', {
        attrs: {
          "confirm": "",
          "placement": "right",
          "title": moreItem.confirmTitle
        },
        on: {
          "on-ok": function ($event) {
            return moreItem.callBack(moreItem.code, item);
          }
        }
      }, [_vm._v(" " + _vm._s(moreItem.name) + " ")]) : _c('span', [_vm._v(_vm._s(moreItem.name))])], 1);
    }), 0)], 1) : _vm._e()], 1)]), _c('s-tree-list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.expand,
        expression: "item.expand"
      }],
      attrs: {
        "increment": _vm.count,
        "data": item.children
      },
      on: {
        "changeSelect": _vm.onSelect
      }
    })], 1);
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };